import { Navigate, useLocation } from 'react-router-dom'
import { getHrefWithThreadPreservation } from '@/utils/thread-navigation'

/**
 * Navigate that preserves `thread` when redirecting (e.g. catch-all routes).
 * Empty `to` redirects to the current focus index. Query strings on `to` are kept;
 * `thread` from the current URL is merged via {@link getHrefWithThreadPreservation}.
 */
export function NavigateWithThread({ to }: { to: string }) {
  const location = useLocation()

  let target = to
  if (to === '') {
    const pathParts = location.pathname.split('/').filter(Boolean)
    const focusRoute = pathParts[0] || 'candidate'
    target = `/${focusRoute}`
  }

  return <Navigate to={getHrefWithThreadPreservation(target)} replace />
}
